let iconAnchor = new google.maps.Point(22, 22);
let iconSize = new google.maps.Size(44, 44);

export let icon = {
  url: window.location.protocol + "//" + window.location.hostname + '/assets/images/map/marker-pin.svg',
  anchor: iconAnchor,
  scaledSize: iconSize,
  size: iconSize,
  optimize: false
};

export let iconActive = {
  url: window.location.protocol + "//" + window.location.hostname + '/assets/images/map/marker-pin-active.svg',
  anchor: iconAnchor,
  scaledSize: iconSize,
  size: iconSize,
  optimize: false
};

export let mapStyles = [
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      { visibility: "simplified" },
      { saturation: -51 },
      { lightness: 22 }
    ]
  },{
    featureType: "all",
    elementType: "geometry",
    stylers: [
      { visibility: "simplified" },
      { saturation: -100 }
    ]
  },{
    featureType: "all",
    elementType: "labels",
    stylers: [
      { saturation: -100 },
      { lightness: 52 },
      { invert_lightness: true },
      { visibility: "off" }
    ]
  },{
    featureType: "road.local",
    elementType: "labels",
    stylers: [
      { visibility: "on" },
      { invert_lightness: true },
      { gamma: 0.69 }
    ]
  },{
    featureType: "administrative.locality",
    elementType: "labels",
    stylers: [
      { visibility: "on" },
      { invert_lightness: true },
      { gamma: 0.62 }
    ]
  }
];

export let mapOptions = {
  styles: mapStyles,
  // center: {
  //   lat: -64.5,
  //   lng: 150.5
  // },
  // zoom: 8
};

export let mapOptionsRestricted = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: false,
  streetViewControl: false,
  signInControl: false,
  scrollwheel: false,
  scaleControl: false,
  rotateControl: false,
  panControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  draggable: false,
  cursor: 'default',
  draggableCursor: 'default'
};



// WEBPACK FOOTER //
// ./src/components/03-ui/gmap/gmap-helpers.js